webpackJsonp([3,7],{

/***/ 137:
/***/ function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(58);

var _vue = __webpack_require__(65);

var _vue2 = _interopRequireDefault(_vue);

var _app = __webpack_require__(386);

var _app2 = _interopRequireDefault(_app);

var _vueTranslatePlugin = __webpack_require__(64);

var _vueTranslatePlugin2 = _interopRequireDefault(_vueTranslatePlugin);

var _vuerify = __webpack_require__(66);

var _vuerify2 = _interopRequireDefault(_vuerify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vueTranslatePlugin2.default);
_vue2.default.use(_vuerify2.default);

var vm = new _vue2.default({
  el: '#app',
  render: function render(h) {
    return h(_app2.default);
  }
});

/***/ },

/***/ 150:
/***/ function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'CarouselNew',
  data: function data() {
    return {
      interval: 10000,
      backgroundClass: 'bg-zero',
      itemState: 'zero',
      count: 0,
      intervalID: undefined,
      headlines: [{
        active: true,
        title: 'headlineZeroTitle',
        description: 'headLineZeroDescp',
        imageURL: 'assets/images/carousel/item0.png',
        iconClass: 'en-docode',
        state: 'zero'
      }, {
        title: 'headlineOneTitle',
        description: 'headLineOneDescp',
        imageURL: 'assets/images/carousel/item1.png',
        iconClass: 'en-qr-code',
        state: 'one'
      }, {
        title: 'headlineTwoTitle',
        description: 'headLineTwoDescp',
        imageURL: 'assets/images/carousel/item2.png',
        iconClass: 'en-user',
        state: 'two'
      }, {
        title: 'headlineThreeTitle',
        description: 'headLineThreeDescp',
        imageURL: 'assets/images/carousel/item3.png',
        iconClass: 'en-bar-chart',
        state: 'three'
      }]
    };
  },

  methods: {
    changeHeadline: function changeHeadline(index, headline) {
      this.count = index;
      this.switchHeadline(headline);
      this.restartInterval();
    },
    switchHeadline: function switchHeadline(headline) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this.headlines[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var hl = _step.value;

          this.$set(hl, 'active', false);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.$set(headline, 'active', true);
      this.backgroundClass = 'bg-' + headline.state;
      this.itemState = headline.state;
    },
    restartInterval: function restartInterval() {
      if (this.intervalID) {
        clearInterval(this.intervalID);
      }

      this.intervalID = setInterval(this.slideInterval, this.interval);
    },
    slideInterval: function slideInterval() {
      this.count += 1;
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = this.headlines[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var hl = _step2.value;

          this.$set(hl, 'active', false);
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      var length = this.headlines.length;
      this.switchHeadline(this.headlines[this.count % length]);
    }
  },
  created: function created() {
    this.restartInterval();
  },
  destroyed: function destroyed() {
    if (this.intervalID) {
      clearInterval(this.intervalID);
    }
  },

  locales: {
    en: {
      headlineZeroTitle: 'Make change, take mobile',
      headlineZeroDescp: 'The easiest way to accept QR Code payment in the world, seamless and effortless.',
      headlineOneTitle: 'New standard and trend',
      headlineOneDescp: 'QR code is not a strange concept,while making payment with QR code is a new area in payment industry. Everonet establishes a new standard and invents more product concepts in QR payment industry. Making QR payment easy and touchable\n          to everyone.',
      headlineTwoTitle: 'Amazing rapid growth',
      headlineTwoDescp: 'Simple, convenient, and easy to learn, those features makes QR payment a new but widely accepted concept worldwide.\n          The growth of 50% per year amazes everyone. You may experience QR payment at the every corner of the world, It\n          is no longer a dream that travelling around by taking a phone and scanning QR code.',
      headlineThreeTitle: 'Far beyond payment',
      headlineThreeDescp: 'QR payment makes all in one more feasible, more functions like coupons, red packet, discount can be combined with\n          payment by just a simple scan, gone are the days for the complex procedures.'
    },
    jp: {
      headlineZeroTitle: 'Make change, take mobile',
      headlineZeroDescp: 'The easiest way to accept QR Code payment in the world, seamless and effortless.',
      headlineOneTitle: '新基準とトレンド',
      headlineOneDescp: 'QR\u30B3\u30FC\u30C9\u306F\u6C7A\u3057\u3066\u65B0\u3057\u3044\u3082\u306E\u3067\u306F\u3042\u308A\u307E\u305B\u3093\u304C\u3001\u6C7A\u6E08\u9818\u57DF\u306B\u5229\u7528\u3055\u308C\u305F\u306E\u306F\u6700\u8FD1\u306E\u52D5\u304D\u3067\u3059\u3002Everonet\u306F\u6A19\u6E96\u30BD\u30EA\u30E5\u30FC\u30B7\u30E7\u30F3\u306E\u63D0\u4F9B\u306B\u3088\u308A\u3001QR\u30B3\u30FC\u30C9\u6C7A\u6E08\u306E\u8907\u96D1\u3055\u3092\u8EFD\u6E1B\u3057\u307E\u3057\u305F\u3002\u4ECA\u5F8C\u3082\u5BB9\u6613\u306B\u5C0E\u5165\u3067\u304D\u308B\u3053\u3068\u3092\u52AA\u529B\u3057\u3066\u3044\u304D\u307E\u3059\u3002',
      headlineTwoTitle: '急速の成長',
      headlineTwoDescp: '\u30B7\u30F3\u30D7\u30EB\u3001\u4FBF\u5229\u3001\u5B66\u3073\u6613\u3044\u3068\u3044\u3046\u7279\u5FB4\u304C\u3042\u308A\u3001QR\u30B3\u30FC\u30C9\u6C7A\u6E08\u306F\u5E02\u5834\u306B\u7D20\u65E9\u304F\u8A8D\u3081\u305F\u65B0\u3057\u3044\u6C7A\u6E08\u65B9\u5F0F\u3068\u306A\u308A\u307E\u3057\u305F\u3002\u73FE\u5728\u5E73\u5747\uFF15\uFF10\uFF05\u306E\u6210\u9577\u7387\u3067\u4EBA\u3005\u306B\u9A5A\u304B\u308C\u307E\u3057\u305F\u3002\u8FD1\u3044\u672A\u6765\u3001QR\u30B3\u30FC\u30C9\u6C7A\u6E08\u306F\u4E16\u754C\u306E\u9685\u3005\u3067\u4F53\u9A13\u3067\u304D\u308B\u3088\u3046\u306B\u306A\u308A\u3001\u305F\u3060\u4E00\u53F0\u306E\u30E2\u30D0\u30A4\u30EB\u3067\u4E16\u754C\u5468\u904A\u3059\u308B\u3053\u3068\u306F\u3082\u306F\u3084\u5922\u3067\u306F\u306A\u3044\u3067\u3059\u3002',
      headlineThreeTitle: 'ペイメントを凌ぐ',
      headlineThreeDescp: '\u30B7\u30F3\u30D7\u30EB\u306AQR\u30B3\u30FC\u30C9\u306F\u305D\u308C\u4EE5\u4E0A\u306E\u6A5F\u80FD\u304C\u5099\u3048\u3089\u308C\u307E\u3059\u3002\u30AF\u30FC\u30DD\u30F3\u3001\u304A\u5E74\u7389\u3001\u30DD\u30A4\u30F3\u30C8\u7B49\u7C21\u5358\u306B\u30B9\u30AD\u30E3\u30F3\u3059\u308B\u3053\u3068\u306B\u3088\u3063\u3066\u6A5F\u80FD\u304C\u5B9F\u73FE\u3055\u308C\u307E\u3059\u3002\u4EE5\u524D\u306E\u8907\u96D1\u306A\u696D\u52D9\u51E6\u7406\u304C\u4E0D\u8981\u3068\u306A\u308A\u307E\u3059\u3002'
    }
  }
};

/***/ },

/***/ 151:
/***/ function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'CustomerOpinions',
  data: function data() {
    return {
      lastClick: [-1, -1],
      customers: [[{
        graySRC: 'assets/images/customerOpinions/c-nttd-gray.png',
        coloredSRC: 'assets/images/customerOpinions/c-nttd-colored.png',
        opinion: 'Our company is to use the company\'s related products of ATL interface, the interface in recent years the use\n            of a more stable,the price is right, our company for this product is quite satisfactory.'
      }, {
        graySRC: 'assets/images/customerOpinions/c-nri-gray.png',
        coloredSRC: 'assets/images/customerOpinions/c-nri-colored.png',
        opinion: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer posuere erat a ante.'
      }, {
        graySRC: 'assets/images/customerOpinions/c-7fs-gray.png',
        coloredSRC: 'assets/images/customerOpinions/c-7fs-colored.png',
        opinion: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer posuere erat a ante.'
      }, {
        graySRC: 'assets/images/customerOpinions/c-univa-gray.png',
        coloredSRC: 'assets/images/customerOpinions/c-univa-colored.png',
        opinion: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer posuere erat a ante.'
      }, {
        graySRC: 'assets/images/customerOpinions/c-alipay-gray.png',
        coloredSRC: 'assets/images/customerOpinions/c-alipay-colored.png',
        opinion: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer posuere erat a ante.'
      }], [{
        graySRC: 'assets/images/customerOpinions/c-wechat-gray.png',
        coloredSRC: 'assets/images/customerOpinions/c-wechat-colored.png',
        opinion: 'Our company is to use the company\'s related products of ATL interface, the interface in recent years the use\n            of a more stable,the price is right, our company for this product is quite satisfactory.'
      }, {
        graySRC: 'assets/images/customerOpinions/c-ms-gray.png',
        coloredSRC: 'assets/images/customerOpinions/c-ms-colored.png',
        opinion: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer posuere erat a ante.'
      }, {
        graySRC: 'assets/images/customerOpinions/c-narita-gray.png',
        coloredSRC: 'assets/images/customerOpinions/c-narita-colored.png',
        opinion: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer posuere erat a ante.'
      }, {
        graySRC: 'assets/images/customerOpinions/c-tiat-gray.png',
        coloredSRC: 'assets/images/customerOpinions/c-tiat-colored.png',
        opinion: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer posuere erat a ante.'
      }, {
        graySRC: 'assets/images/customerOpinions/c-711-gray.png',
        coloredSRC: 'assets/images/customerOpinions/c-711-colored.png',
        opinion: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer posuere erat a ante.'
      }], [{
        graySRC: 'assets/images/customerOpinions/c-ah-gray.png',
        coloredSRC: 'assets/images/customerOpinions/c-ah-colored.png',
        opinion: 'Our company is to use the company\'s related products of ATL interface, the interface in recent years the use\n            of a more stable,the price is right, our company for this product is quite satisfactory.'
      }, {
        graySRC: 'assets/images/customerOpinions/c-tokyu-gray.png',
        coloredSRC: 'assets/images/customerOpinions/c-tokyu-colored.png',
        opinion: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer posuere erat a ante.'
      }, {
        graySRC: 'assets/images/customerOpinions/c-odakyu-gray.png',
        coloredSRC: 'assets/images/customerOpinions/c-odakyu-colored.png',
        opinion: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer posuere erat a ante.'
      }, {
        graySRC: 'assets/images/customerOpinions/c-takeiya-gray.png',
        coloredSRC: 'assets/images/customerOpinions/c-takeiya-colored.png',
        opinion: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer posuere erat a ante.'
      }, {
        graySRC: 'assets/images/customerOpinions/c-kirindo-gray.png',
        coloredSRC: 'assets/images/customerOpinions/c-kirindo-colored.png',
        opinion: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer posuere erat a ante.'
      }], [{
        graySRC: 'assets/images/customerOpinions/c-harrods-gray.png',
        coloredSRC: 'assets/images/customerOpinions/c-harrods-colored.png',
        opinion: 'Our company is to use the company\'s related products of ATL interface, the interface in recent years the use\n            of a more stable,the price is right, our company for this product is quite satisfactory.'
      }, {
        graySRC: 'assets/images/customerOpinions/c-selfridges-gray.png',
        coloredSRC: 'assets/images/customerOpinions/c-selfridges-colored.png',
        opinion: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer posuere erat a ante.'
      }, {
        graySRC: 'assets/images/customerOpinions/c-hnb-gray.png',
        coloredSRC: 'assets/images/customerOpinions/c-hnb-colored.png',
        opinion: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer posuere erat a ante.'
      }, {
        graySRC: 'assets/images/customerOpinions/c-jr-gray.png',
        coloredSRC: 'assets/images/customerOpinions/c-jr-colored.png',
        opinion: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer posuere erat a ante.'
      }, {
        more: true
      }]]
    };
  },

  methods: {
    click: function click(customer, row, column) {
      var idx = this.lastClick;
      if (idx[0] >= 0 && idx[1] >= 0) {
        if (!(idx[0] === row && idx[1] === column)) {
          this.customers[idx[0]][idx[1]].isActive = false;
        }
      }
      this.$set(customer, 'isActive', !!!customer.isActive);
      this.lastClick = [row, column];
    }
  },
  locales: {
    en: {
      title: 'CUSTOMERS\' OPINIONS'
    },
    jp: {
      title: '成功事例'
    }
  }
};

/***/ },

/***/ 152:
/***/ function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'ProductCenter',
  data: function data() {
    return {
      products: [[{
        url: 'assets/images/productCenter/smartAPP.png',
        title: 'smartAPP',
        link: './products.html#smartAPP'
      }, {
        url: 'assets/images/productCenter/elitePOS.png',
        title: 'elitePOS',
        link: './products.html#elitePOS'
      }, {
        url: 'assets/images/productCenter/cashierAggregator.png',
        title: 'cashierAggregator',
        link: './products.html#cashierAggregator'
      }], [{
        url: 'assets/images/productCenter/embraceCapability.png',
        title: 'embraceCapability',
        link: './products.html#embraceCapability'
      }, {
        url: 'assets/images/productCenter/dashboard.png',
        title: 'visibleDashboard',
        link: './products.html#visibleDashboard'
      }, {
        url: 'assets/images/productCenter/beyondImagination.png',
        title: 'beyondImagination',
        link: './products.html#beyondImagin'
      }]]
    };
  },

  locales: {
    en: {
      productCenterTitle: 'PRODUCT CENTER',
      smartAPP: 'Smart APP',
      cashierAggregator: 'Cashier Aggregator',
      visibleDashboard: 'Dashboard',
      elitePOS: 'Elite POS',
      embraceCapability: 'Embrace Capability',
      beyondImagination: 'Beyond Imagination'
    },
    jp: {
      productCenterTitle: '製品ライン',
      smartAPP: 'スマートAPP',
      cashierAggregator: 'PCレジ',
      visibleDashboard: 'データ可視化',
      elitePOS: 'スマートCCT端末',
      embraceCapability: '拡張性',
      beyondImagination: 'ビジョン'
    }
  }
};

/***/ },

/***/ 153:
/***/ function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Navigator = __webpack_require__(32);

var _Navigator2 = _interopRequireDefault(_Navigator);

var _EnFooter = __webpack_require__(31);

var _EnFooter2 = _interopRequireDefault(_EnFooter);

var _CarouselNew = __webpack_require__(383);

var _CarouselNew2 = _interopRequireDefault(_CarouselNew);

var _ProductCenter = __webpack_require__(385);

var _ProductCenter2 = _interopRequireDefault(_ProductCenter);

var _CustomerOpinions = __webpack_require__(384);

var _CustomerOpinions2 = _interopRequireDefault(_CustomerOpinions);

var _ContactUs = __webpack_require__(30);

var _ContactUs2 = _interopRequireDefault(_ContactUs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'app',
  components: {
    Navigator: _Navigator2.default,
    EnFooter: _EnFooter2.default,
    CarouselNew: _CarouselNew2.default,
    ProductCenter: _ProductCenter2.default,
    CustomerOpinions: _CustomerOpinions2.default,
    ContactUs: _ContactUs2.default
  },
  created: function created() {
    var height = this.visibleHeight();
    if (height < 700) {
      height = 700;
    } else if (height > 1080) {
      height = 1080;
    }
    this.height = height + 'px';

    console.log('created');
  },
  data: function data() {
    return {
      index: 1,
      height: 1024,
      scrollings: [],
      prevTime: new Date().getTime()
    };
  },

  methods: {
    visibleHeight: function visibleHeight() {
      return window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight || 0;
    },
    mouseWheelHandler: function mouseWheelHandler(e) {
      e.preventDefault();
      var curTime = new Date().getTime();

      e = window.event || e || e.originalEvent;

      var value = e.wheelDelta || -e.deltaY || -e.detail;
      var delta = Math.max(-1, Math.min(1, value));
      window.scroll(0, window.scorllY + value);
      console.log('value', value);
      console.log('delta', delta);
      if (this.scrollings.length > 149) {
        this.scrollings.shift();
      }

      this.scrollings.push(Math.abs(value));
      var timeDiff = curTime - this.prevTime;
      this.prevTime = curTime;
      if (timeDiff > 200) {
        this.scrollings = [];
      }

      var averageEnd = this.getAverage(this.scrollings, 10);
      var averageMiddle = this.getAverage(this.scrollings, 70);
      console.log(averageEnd, averageMiddle, this.scrollings);
      var isAccelerating = averageEnd >= averageMiddle;

      if (isAccelerating) {
        if (delta < 0) {
          console.log('down');
          this.scrolling('down');
        } else {
          console.log('up');
        }
      }

      return true;
    },
    scrolling: function scrolling(type) {
      var height = void 0;
      if (type === 'down') {
        this.index++;
      } else {
        this.index--;
      }
      height = '-' + this.height * this.index + 'px';
      document.querySelectorAll('.section').forEach(function (a) {
        a.style.transform = 'translate3d(0, ' + height + ', 0)';
      });
    },
    getAverage: function getAverage(elements, number) {
      var sum = 0;

      var lastElements = elements.slice(Math.max(elements.length - number, 1));

      for (var i = 0; i < lastElements.length; i++) {
        sum = sum + lastElements[i];
      }
      return Math.ceil(sum / number);
    }
  }
};

/***/ },

/***/ 173:
/***/ function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ },

/***/ 175:
/***/ function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ },

/***/ 179:
/***/ function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ },

/***/ 183:
/***/ function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ },

/***/ 19:
/***/ function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'ContactUs',
  props: ['place'],
  locales: {
    en: {
      telephone: '+86-21-60278098',
      companyAddress: '9F,Building C,Wison Plaza,No.699 Zhongke Rd,Pudong District,Shanghai 201210,China'
    },
    jp: {
      telephone: '03-5847-7996',
      companyAddress: '東京都中央区日本橋兜町5-1  兜町第1平和ビル3階'
    }
  },
  data: function data() {
    return {
      countdown: 0,
      sended: false,
      sending: false,
      needCheck: true,
      showTopBG: false,
      topBGColor: 'transparent',
      topBGImageURL: '',
      topBGTopOffest: '-48px',
      marginTop: '0',
      bgColor: 'transparent',
      height: '1024px',
      bgImageURL: '',
      bgImageMap: {
        index: '/assets/images/contactUs/shanghai-bg.png',
        indexJP: '/assets/images/contactUs/japan-bg.png',
        product: '/assets/images/contactUs/product-bg.png',
        about: '/assets/images/contactUs/about-bg.png'
      },
      topBGImageMap: {
        product: 'assets/images/contactUs/balloon-bg.png',
        start: 'assets/images/contactUs/start-bg.png'
      },
      email: '',
      fullName: '',
      msgText: ''
    };
  },

  vuerify: {
    fullName: {
      test: /.+/,
      message: 'Please input fullname'
    },
    email: [{
      test: /.+/,
      message: 'Please input email'
    }, {
      test: /^[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9.\-]+\.[a-zA-Z]{2,4}$/,
      message: 'Please input a correct email'
    }],
    msgText: {
      test: /.+/,
      message: 'Please input message'
    }
  },
  computed: {
    emailError: function emailError() {
      if (this.$vuerify.$errors['email']) {
        return this.$vuerify.$errors['email'][0];
      }
      return '';
    },
    sendMessageText: function sendMessageText() {
      if (this.countdown === 0) {
        return 'SEND MESSAGE';
      } else if (this.countdown < 0) {
        return 'UNAVAILABLE';
      }

      return 'SEND MESSAGE after ' + this.countdown + 's';
    }
  },
  created: function created() {
    var _this = this;

    var height = document.documentElement.clientHeight;
    this.height = height + 'px';
    var bgURL = this.bgImageMap.product;
    if (this.bgImageMap[this.place]) {
      bgURL = this.bgImageMap[this.place];
    }

    switch (this.place) {
      case 'index':
        this.bgColor = '#F1F7FC';
        this.$translate.$on('language:init', function (language) {
          if (language === 'jp') {
            _this.bgImageURL = 'url(\'' + _this.bgImageMap.indexJP + '\')';
          }
        });

        this.$translate.$on('language:changed', function (language) {
          if (language === 'jp') {
            _this.bgImageURL = 'url(\'' + _this.bgImageMap.indexJP + '\')';
          } else {
            _this.bgImageURL = 'url(\'' + _this.bgImageMap.index + '\')';
          }
        });
        break;
      case 'product':
        this.marginTop = '80px';
        this.height = 'auto';
        this.showTopBG = true;
        this.topBGColor = '#F1F7FC';
        this.topBGImageURL = this.topBGImageMap.product;
        this.topBGTopOffest = '-80px';
        this.bgColor = 'transparent';
        break;
      case 'about':
        this.height = 'auto';
        this.bgColor = 'transparent';
        break;
      case 'techspec':
        this.height = 'auto';
        this.bgColor = '#EFF7FD';
        break;
      case 'start':
        this.showTopBG = true;
        this.topBGImageURL = this.topBGImageMap.start;
        this.height = 'auto';
        this.bgColor = 'transparent';
        break;
      default:
        break;
    }
    this.bgImageURL = 'url(\'' + bgURL + '\')';
  },

  methods: {
    sendMessage: function sendMessage() {
      if (this.countdown > 0) {
        return;
      }

      this.needCheck = true;
      if (!this.$vuerify.check()) {
        return;
      }

      this.countdown = 60;

      this.sending = true;
      var message = {
        fullName: this.fullName,
        email: this.email,
        message: this.msgText
      };

      var server =  true ? 'https://portal.everonet.com' : 'http://localhost:6900';
      var xhr = new XMLHttpRequest();
      xhr.onreadystatechange = function () {
        if (xhr.readyState === xhr.DONE) {
          this.sending = false;
          switch (xhr.status) {
            case 200:
              this.sended = true;
              this.needCheck = false;
              this.fullName = '';
              this.email = '';
              this.msgText = '';
              this.$vuerify.clear();

              setTimeout(function () {
                this.sended = false;
              }.bind(this), 8000);

              this.interval = setInterval(function () {
                this.countdown = this.countdown - 1;
                if (this.countdown === 0) {
                  clearInterval(this.interval);
                }
              }.bind(this), 1000);
              break;
            case 400:
              alert('Please check the form data is OK?');
              this.countdown = 0;
              break;
            default:
              this.countdown = -1;
          }
        }
      }.bind(this);

      xhr.open('POST', server + '/public/everonet/message');
      xhr.send(JSON.stringify(message));
    }
  }
};

/***/ },

/***/ 20:
/***/ function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _LanguageSwitch = __webpack_require__(9);

var _LanguageSwitch2 = _interopRequireDefault(_LanguageSwitch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'EnFooter',
  components: {
    LanguageSwitch: _LanguageSwitch2.default
  }
};

/***/ },

/***/ 21:
/***/ function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});


var rclass = /[\t\r\n]/g;
var storeKey = 'EVERONET_LOCALE';
var defaultLanguage = 'en';
exports.default = {
  name: 'LanguageSwitch',
  data: function data() {
    return {
      i18n: [{
        key: 'en',
        display: 'En'
      }, {
        key: 'jp',
        display: 'Jp'
      }],
      langKey: defaultLanguage
    };
  },
  created: function created() {
    var _this = this;

    var langKey = this.getStoredLanguage();
    if (langKey === '') {
      langKey = this.getLanguageFromBrowser();
    }

    this.i18n = this.i18n.map(function (item) {
      if (item.key === langKey) {
        item.active = true;
      }
      return item;
    });
    this.langKey = langKey;

    this.$translate.$on('language:init', function (language) {
      _this.languageClass(language);
    });

    this.$translate.$on('language:changed', function (language) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = _this.i18n[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var item = _step.value;

          if (item.key === language) {
            _this.$set(item, 'active', true);
          } else {
            _this.$set(item, 'active', false);
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      _this.languageClass(language);
    });
  },
  mounted: function mounted() {
    this.$translate.setLang(this.langKey);
  },

  methods: {
    languageClass: function languageClass(language) {
      var body = document.querySelector('body');
      if (language === 'jp') {
        this.addClass(body, 'japanese');
      } else {
        this.removeClass(body, 'japanese');
      }
    },
    setLanguage: function setLanguage(key) {
      this.$translate.setLang(key);
      this.setStoredLanguage(key);
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = this.i18n[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var item = _step2.value;

          if (item.key === key) {
            this.$set(item, 'active', true);
          } else {
            this.$set(item, 'active', false);
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    },
    getStoredLanguage: function getStoredLanguage() {
      var lang = localStorage.getItem(storeKey);
      if (typeof lang === 'string') {
        return lang;
      }
      return '';
    },
    setStoredLanguage: function setStoredLanguage(key) {
      localStorage.setItem(storeKey, key);
    },
    getLanguageFromBrowser: function getLanguageFromBrowser() {
      var language = navigator.browserLanguage ? navigator.browserLanguage : navigator.language;
      if (language.toLowerCase().indexOf('ja') > -1) {
        return 'jp';
      }
      return defaultLanguage;
    },
    addClass: function addClass(ele, clazz) {
      if (this.hasClass(ele, clazz)) {
        return;
      }

      var cur = ele.nodeType === 1 && (ele.className ? (' ' + ele.className + ' ').replace(rclass, ' ') : ' ');
      cur += clazz + ' ';
      ele.className = cur.trim();
    },
    removeClass: function removeClass(ele, clazz) {
      if (!this.hasClass(ele, clazz)) {
        return;
      }

      var cur = ele.nodeType === 1 && (ele.className ? (' ' + ele.className + ' ').replace(rclass, ' ') : ' ');
      cur = cur.replace(' ' + clazz + ' ', '');
      ele.className = cur.trim();
    },
    hasClass: function hasClass(ele, clazz) {
      var className = ' ' + clazz + ' ';
      if (ele.nodeType === 1 && (' ' + ele.className + ' ').replace(rclass, '').indexOf(className) >= 0) {
        return true;
      }

      return false;
    }
  }
};

/***/ },

/***/ 22:
/***/ function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _LanguageSwitch = __webpack_require__(9);

var _LanguageSwitch2 = _interopRequireDefault(_LanguageSwitch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HOVER_CLASS = 'hover';
exports.default = {
  name: 'Navigator',
  components: {
    LanguageSwitch: _LanguageSwitch2.default
  },
  locales: {
    en: {
      smartAPP: 'SMART APP',
      cashierAggregator: 'CASHIER AGGREGATOR',
      visibleDashboard: 'VISIBLE DASHBOARD',
      elitePOS: 'ELITE POS',
      embraceCapability: 'EMBRACE CAPABILITY',
      beyondImagination: 'BEYOND IMAGINATION'
    },
    jp: {
      smartAPP: 'スマートAPP',
      cashierAggregator: 'PCレジ',
      visibleDashboard: 'データ可視化',
      elitePOS: 'スマートCCT端末',
      embraceCapability: '拡張性',
      beyondImagination: 'ビジョン'
    }
  }
};

/***/ },

/***/ 23:
/***/ function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ },

/***/ 24:
/***/ function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ },

/***/ 25:
/***/ function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ },

/***/ 26:
/***/ function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ },

/***/ 30:
/***/ function(module, exports, __webpack_require__) {

var __vue_exports__, __vue_options__
var __vue_styles__ = {}

/* styles */
__webpack_require__(26)

/* script */
__vue_exports__ = __webpack_require__(19)

/* template */
var __vue_template__ = __webpack_require__(36)
__vue_options__ = __vue_exports__ = __vue_exports__ || {}
if (
  typeof __vue_exports__.default === "object" ||
  typeof __vue_exports__.default === "function"
) {
__vue_options__ = __vue_exports__ = __vue_exports__.default
}
if (typeof __vue_options__ === "function") {
  __vue_options__ = __vue_options__.options
}

__vue_options__.render = __vue_template__.render
__vue_options__.staticRenderFns = __vue_template__.staticRenderFns

module.exports = __vue_exports__


/***/ },

/***/ 31:
/***/ function(module, exports, __webpack_require__) {

var __vue_exports__, __vue_options__
var __vue_styles__ = {}

/* styles */
__webpack_require__(23)

/* script */
__vue_exports__ = __webpack_require__(20)

/* template */
var __vue_template__ = __webpack_require__(33)
__vue_options__ = __vue_exports__ = __vue_exports__ || {}
if (
  typeof __vue_exports__.default === "object" ||
  typeof __vue_exports__.default === "function"
) {
__vue_options__ = __vue_exports__ = __vue_exports__.default
}
if (typeof __vue_options__ === "function") {
  __vue_options__ = __vue_options__.options
}

__vue_options__.render = __vue_template__.render
__vue_options__.staticRenderFns = __vue_template__.staticRenderFns

module.exports = __vue_exports__


/***/ },

/***/ 32:
/***/ function(module, exports, __webpack_require__) {

var __vue_exports__, __vue_options__
var __vue_styles__ = {}

/* styles */
__webpack_require__(24)

/* script */
__vue_exports__ = __webpack_require__(22)

/* template */
var __vue_template__ = __webpack_require__(34)
__vue_options__ = __vue_exports__ = __vue_exports__ || {}
if (
  typeof __vue_exports__.default === "object" ||
  typeof __vue_exports__.default === "function"
) {
__vue_options__ = __vue_exports__ = __vue_exports__.default
}
if (typeof __vue_options__ === "function") {
  __vue_options__ = __vue_options__.options
}

__vue_options__.render = __vue_template__.render
__vue_options__.staticRenderFns = __vue_template__.staticRenderFns

module.exports = __vue_exports__


/***/ },

/***/ 33:
/***/ function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "enFooter"
    }
  }, [_vm._m(0), _vm._v(" "), _c('language-switch', {
    staticClass: "inverse"
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer-info"
  }, [_c('div', {
    staticClass: "footer-nav"
  }, [_c('div', {
    staticClass: "brand-name"
  }, [_c('a', {
    attrs: {
      "href": "./"
    }
  }, [_c('img', {
    attrs: {
      "src": "assets/images/logo_gray.png",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "footer-navbar"
  }, [_c('ul', {
    staticClass: "nav navbar-nav"
  }, [_c('li', {
    staticClass: "active"
  }, [_c('a', {
    attrs: {
      "href": "./products.html"
    }
  }, [_vm._v("PRODUCTS")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "./start.html"
    }
  }, [_vm._v("HOW TO START")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "./about.html"
    }
  }, [_vm._v("ABOUT US")])])])])]), _vm._v(" "), _c('p', [_vm._v("© 2017, Everonet, a subsidiary company of CardInfoLink. All rights reserved.")]), _vm._v(" "), _c('p', [_vm._v("沪 ICP 备 11004387 号")])])
}]}

/***/ },

/***/ 34:
/***/ function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navbar-wrapper"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('nav', {
    staticClass: "navbar",
    attrs: {
      "role": "navigation"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "navbar-collapse collapse",
    attrs: {
      "id": "navbar"
    }
  }, [_c('ul', {
    staticClass: "nav navbar-nav"
  }, [_c('li', {
    staticClass: "active has-popover"
  }, [_c('a', {
    attrs: {
      "href": "./products.html"
    }
  }, [_vm._v("PRODUCTS")]), _vm._v(" "), _c('div', {
    staticClass: "popover bottom",
    attrs: {
      "id": "productPopover"
    }
  }, [_c('div', {
    staticClass: "arrow"
  }), _vm._v(" "), _c('div', {
    staticClass: "popover-content"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "popover-products-wrapper"
  }, [_c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "./products.html#smartAPP"
    }
  }, [_vm._v(_vm._s(_vm.t('smartAPP')))])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "./products.html#cashierAggregator"
    }
  }, [_vm._v(_vm._s(_vm.t('cashierAggregator')))])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "./products.html#visibleDashboard"
    }
  }, [_vm._v(_vm._s(_vm.t('visibleDashboard')))])])]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "./products.html#elitePOS"
    }
  }, [_vm._v(_vm._s(_vm.t('elitePOS')))])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "./products.html#embraceCapability"
    }
  }, [_vm._v(_vm._s(_vm.t('embraceCapability')))])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "./products.html#beyondImagin"
    }
  }, [_vm._v(_vm._s(_vm.t('beyondImagination')))])])])])])])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3)])]), _vm._v(" "), _c('language-switch', {
    attrs: {
      "id": "languageSwitch"
    }
  })], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navbar-header"
  }, [_c('a', {
    staticClass: "navbar-brand",
    attrs: {
      "href": "./"
    }
  }, [_c('img', {
    attrs: {
      "src": "assets/images/logo.png",
      "alt": ""
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "popover-product-new"
  }, [_c('a', {
    attrs: {
      "href": "./docode.html"
    }
  }, [_vm._v("DOCODE"), _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("NEW")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "./start.html"
    }
  }, [_vm._v("HOW TO START")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "./about.html"
    }
  }, [_vm._v("ABOUT US")])])
}]}

/***/ },

/***/ 35:
/***/ function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "language-switch"
  }, _vm._l((_vm.i18n), function(lang) {
    return _c('li', {
      class: {
        'active': lang.active
      }
    }, [_c('a', {
      on: {
        "click": function($event) {
          _vm.setLanguage(lang.key)
        }
      }
    }, [_vm._v(_vm._s(lang.display))])])
  }))
},staticRenderFns: []}

/***/ },

/***/ 36:
/***/ function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    style: ({
      height: _vm.height,
      'margin-top': _vm.marginTop
    }),
    attrs: {
      "id": "contactUs"
    }
  }, [(_vm.showTopBG) ? _c('div', {
    staticClass: "top-bg-wrapper",
    style: ({
      top: _vm.topBGTopOffest,
      'background-color': _vm.topBGColor
    })
  }, [_c('img', {
    attrs: {
      "src": _vm.topBGImageURL,
      "alt": ""
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "bg-wrapper",
    style: ({
      'background-image': _vm.bgImageURL,
      'background-color': _vm.bgColor
    })
  }), _vm._v(" "), _c('span', {
    staticClass: "en-email"
  }, [_vm._v("sales@everonet.com")]), _vm._v(" "), _c('h1', {
    staticClass: "en-tel"
  }, [_vm._v(_vm._s(_vm.t('telephone')))]), _vm._v(" "), _c('small', {
    staticClass: "en-address"
  }, [_vm._v(_vm._s(_vm.t('companyAddress')))]), _vm._v(" "), _c('form', {
    staticClass: "en-form"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.fullName),
      expression: "fullName",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text",
      "id": "fullName",
      "placeholder": "Full name"
    },
    domProps: {
      "value": _vm._s(_vm.fullName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fullName = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.needCheck && _vm.$vuerify.$errors['fullName']),
      expression: "needCheck && $vuerify.$errors['fullName']"
    }],
    staticClass: "tooltip right"
  }, [_c('div', {
    staticClass: "tooltip-arrow"
  }), _vm._v(" "), _c('div', {
    staticClass: "tooltip-inner"
  }, [_vm._v(_vm._s(_vm.$vuerify.$errors['fullName']))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.email),
      expression: "email",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text",
      "placeholder": "Email address"
    },
    domProps: {
      "value": _vm._s(_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.needCheck && _vm.emailError),
      expression: "needCheck && emailError"
    }],
    staticClass: "tooltip right"
  }, [_c('div', {
    staticClass: "tooltip-arrow"
  }), _vm._v(" "), _c('div', {
    staticClass: "tooltip-inner"
  }, [_vm._v(_vm._s(_vm.emailError))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.msgText),
      expression: "msgText",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "placeholder": "Message"
    },
    domProps: {
      "value": _vm._s(_vm.msgText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.msgText = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.needCheck && _vm.$vuerify.$errors['msgText']),
      expression: "needCheck && $vuerify.$errors['msgText']"
    }],
    staticClass: "tooltip right"
  }, [_c('div', {
    staticClass: "tooltip-arrow"
  }), _vm._v(" "), _c('div', {
    staticClass: "tooltip-inner"
  }, [_vm._v(_vm._s(_vm.$vuerify.$errors['msgText']))])])]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.sending),
      expression: "!sending"
    }],
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.sendMessage($event)
      }
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.sended),
      expression: "!sended"
    }]
  }, [_vm._v(_vm._s(_vm.sendMessageText))]), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.sended),
      expression: "sended"
    }],
    staticClass: "en en-checkmark"
  })]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.sending),
      expression: "sending"
    }],
    staticClass: "spinner-button"
  }, [_vm._m(0)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner"
  }, [_c('div', {
    staticClass: "bounce1"
  }), _vm._v(" "), _c('div', {
    staticClass: "bounce2"
  }), _vm._v(" "), _c('div', {
    staticClass: "bounce3"
  })])
}]}

/***/ },

/***/ 383:
/***/ function(module, exports, __webpack_require__) {

var __vue_exports__, __vue_options__
var __vue_styles__ = {}

/* styles */
__webpack_require__(175)

/* script */
__vue_exports__ = __webpack_require__(150)

/* template */
var __vue_template__ = __webpack_require__(408)
__vue_options__ = __vue_exports__ = __vue_exports__ || {}
if (
  typeof __vue_exports__.default === "object" ||
  typeof __vue_exports__.default === "function"
) {
__vue_options__ = __vue_exports__ = __vue_exports__.default
}
if (typeof __vue_options__ === "function") {
  __vue_options__ = __vue_options__.options
}

__vue_options__.render = __vue_template__.render
__vue_options__.staticRenderFns = __vue_template__.staticRenderFns

module.exports = __vue_exports__


/***/ },

/***/ 384:
/***/ function(module, exports, __webpack_require__) {

var __vue_exports__, __vue_options__
var __vue_styles__ = {}

/* styles */
__webpack_require__(179)

/* script */
__vue_exports__ = __webpack_require__(151)

/* template */
var __vue_template__ = __webpack_require__(412)
__vue_options__ = __vue_exports__ = __vue_exports__ || {}
if (
  typeof __vue_exports__.default === "object" ||
  typeof __vue_exports__.default === "function"
) {
__vue_options__ = __vue_exports__ = __vue_exports__.default
}
if (typeof __vue_options__ === "function") {
  __vue_options__ = __vue_options__.options
}

__vue_options__.render = __vue_template__.render
__vue_options__.staticRenderFns = __vue_template__.staticRenderFns

module.exports = __vue_exports__


/***/ },

/***/ 385:
/***/ function(module, exports, __webpack_require__) {

var __vue_exports__, __vue_options__
var __vue_styles__ = {}

/* styles */
__webpack_require__(183)

/* script */
__vue_exports__ = __webpack_require__(152)

/* template */
var __vue_template__ = __webpack_require__(416)
__vue_options__ = __vue_exports__ = __vue_exports__ || {}
if (
  typeof __vue_exports__.default === "object" ||
  typeof __vue_exports__.default === "function"
) {
__vue_options__ = __vue_exports__ = __vue_exports__.default
}
if (typeof __vue_options__ === "function") {
  __vue_options__ = __vue_options__.options
}

__vue_options__.render = __vue_template__.render
__vue_options__.staticRenderFns = __vue_template__.staticRenderFns

module.exports = __vue_exports__


/***/ },

/***/ 386:
/***/ function(module, exports, __webpack_require__) {

var __vue_exports__, __vue_options__
var __vue_styles__ = {}

/* styles */
__webpack_require__(173)

/* script */
__vue_exports__ = __webpack_require__(153)

/* template */
var __vue_template__ = __webpack_require__(406)
__vue_options__ = __vue_exports__ = __vue_exports__ || {}
if (
  typeof __vue_exports__.default === "object" ||
  typeof __vue_exports__.default === "function"
) {
__vue_options__ = __vue_exports__ = __vue_exports__.default
}
if (typeof __vue_options__ === "function") {
  __vue_options__ = __vue_options__.options
}

__vue_options__.render = __vue_template__.render
__vue_options__.staticRenderFns = __vue_template__.staticRenderFns

module.exports = __vue_exports__


/***/ },

/***/ 406:
/***/ function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    attrs: {
      "id": "container"
    }
  }, [_c('Navigator', {
    staticClass: "section"
  }), _vm._v(" "), _c('CarouselNew', {
    staticClass: "section",
    style: ({
      height: _vm.height
    })
  }), _vm._v(" "), _c('ProductCenter', {
    staticClass: "section",
    style: ({
      height: _vm.height
    })
  }), _vm._v(" "), _c('CustomerOpinions', {
    staticClass: "section",
    style: ({
      height: _vm.height
    })
  }), _vm._v(" "), _c('ContactUs', {
    staticClass: "section",
    style: ({
      height: _vm.height
    }),
    attrs: {
      "place": "index"
    }
  }), _vm._v(" "), _c('EnFooter', {
    staticClass: "section"
  })], 1)
},staticRenderFns: []}

/***/ },

/***/ 408:
/***/ function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: [_vm.backgroundClass],
    attrs: {
      "id": "carouselContainer"
    }
  }, [_vm._m(0), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "animated slideInDown",
      "leave-active-class": "animated fadeOutDownBig"
    }
  }, [(_vm.itemState === 'zero') ? _c('div', {
    key: "zero",
    staticClass: "carousel"
  }, [_c('div', {
    staticClass: "carousel-cell"
  }, [_c('div', {
    staticClass: "carousel-text"
  }, [_c('h1', [_vm._v(_vm._s(_vm.t('headlineZeroTitle')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.t('headlineZeroDescp')))]), _vm._v(" "), _c('a', {
    staticClass: "explore-more-btn",
    attrs: {
      "href": "./docode.html"
    }
  }, [_vm._v("EXPLORE MORE")])])]), _vm._v(" "), _c('div', {
    staticClass: "carousel-cell"
  }, [_c('img', {
    attrs: {
      "width": "60%",
      "src": "assets/images/carousel/item0.png",
      "alt": ""
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.itemState === 'one') ? _c('div', {
    key: "one",
    staticClass: "carousel"
  }, [_c('div', {
    staticClass: "carousel-cell"
  }, [_c('div', {
    staticClass: "carousel-text"
  }, [_c('h1', [_vm._v(_vm._s(_vm.t('headlineOneTitle')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.t('headlineOneDescp')))])])]), _vm._v(" "), _c('div', {
    staticClass: "carousel-cell"
  }, [_c('img', {
    attrs: {
      "width": "70%",
      "src": "assets/images/carousel/item1.png",
      "alt": ""
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.itemState === 'two') ? _c('div', {
    key: "two",
    staticClass: "carousel"
  }, [_c('div', {
    staticClass: "carousel-cell"
  }, [_c('div', {
    staticClass: "carousel-text"
  }, [_c('h1', [_vm._v(_vm._s(_vm.t('headlineTwoTitle')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.t('headlineTwoDescp')))])])]), _vm._v(" "), _c('div', {
    staticClass: "carousel-cell"
  }, [_c('img', {
    attrs: {
      "width": "70%",
      "src": "assets/images/carousel/item2.png",
      "alt": ""
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.itemState === 'three') ? _c('div', {
    key: "three",
    staticClass: "carousel"
  }, [_c('div', {
    staticClass: "carousel-cell"
  }, [_c('div', {
    staticClass: "carousel-text"
  }, [_c('h1', [_vm._v(_vm._s(_vm.t('headlineThreeTitle')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.t('headlineThreeDescp')))])])]), _vm._v(" "), _c('div', {
    staticClass: "carousel-cell"
  }, [_c('img', {
    attrs: {
      "width": "70%",
      "src": "assets/images/carousel/item3.png",
      "alt": ""
    }
  })])]) : _vm._e()]), _vm._v(" "), _c('ol', {
    staticClass: "carousel-indicators"
  }, _vm._l((_vm.headlines), function(hl, hidx) {
    return _c('li', {
      class: {
        'active': hl.active
      },
      on: {
        "click": function($event) {
          _vm.changeHeadline(hidx, hl)
        }
      }
    }, [_c('i', {
      staticClass: "en",
      class: [hl.iconClass],
      attrs: {
        "aria-hidden": "true"
      }
    })])
  }))], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('img', {
    attrs: {
      "src": "assets/images/carousel/bg1.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "assets/images/carousel/bg2.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "assets/images/carousel/bg3.png",
      "alt": ""
    }
  })])
}]}

/***/ },

/***/ 412:
/***/ function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "customerOpinions"
    }
  }, [_c('div', {
    staticClass: "top-bg"
  }), _vm._v(" "), _c('div', {
    staticClass: "inner"
  }, [_c('img', {
    attrs: {
      "src": "assets/images/customerOpinions/customerOpinionsIcon.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "section-title blue"
  }, [_vm._v(_vm._s(_vm.t('title')))]), _vm._v(" "), _c('div', {
    staticClass: "en-customers"
  }, _vm._l((_vm.customers), function(row, i) {
    return _c('div', {
      staticClass: "en-customers-row"
    }, _vm._l((row), function(customer, j) {
      return _c('div', {
        staticClass: "en-customer",
        class: {
          'active': customer.isActive, 'non-customer': customer.more
        }
      }, [(customer.more) ? [_vm._m(0, true)] : [_c('img', {
        attrs: {
          "src": customer.graySRC,
          "alt": ""
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "en-customer-opinion"
      }, [_c('img', {
        attrs: {
          "src": customer.coloredSRC,
          "alt": ""
        }
      }), _vm._v(" "), _c('p', {
        staticClass: "opinion-text"
      }, [_vm._v(_vm._s(customer.opinion))])])]], 2)
    }))
  }))])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mock-customer"
  }, [_c('i', {
    staticClass: "en en-plus"
  })])
}]}

/***/ },

/***/ 416:
/***/ function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "productCenter",
      "name": "productCenter"
    }
  }, [_c('img', {
    attrs: {
      "src": "assets/images/productCenter/productCenterIcon.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "blue section-title"
  }, [_vm._v(_vm._s(_vm.t('productCenterTitle')))]), _vm._v(" "), _c('div', {
    staticClass: "en-products"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.products), function(row) {
    return _c('div', {
      staticClass: "en-product-row"
    }, _vm._l((row), function(item) {
      return _c('a', {
        attrs: {
          "href": item.link
        }
      }, [_c('div', {
        staticClass: "thumbnail"
      }, [_c('div', {
        staticClass: "cover"
      }, [_c('img', {
        attrs: {
          "src": item.url,
          "alt": item.title
        }
      })]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.t(item.title)))])])])
    }))
  })], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "docode-container"
  }, [_c('img', {
    attrs: {
      "src": "assets/images/productCenter/docode.svg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "docode-text"
  }, [_c('h1', [_vm._v("Docode"), _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("NEW")])]), _vm._v(" "), _c('p', [_vm._v("\n          The ultimate solution for mobile payment in the world.\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "explore-more"
  }, [_c('a', {
    attrs: {
      "href": "./docode.html"
    }
  }, [_vm._v("Explore More")])])])
}]}

/***/ },

/***/ 426:
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(137);


/***/ },

/***/ 44:
/***/ function(module, exports) {

var g;

// This works in non-strict mode
g = (function() { return this; })();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ },

/***/ 57:
/***/ function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ },

/***/ 9:
/***/ function(module, exports, __webpack_require__) {

var __vue_exports__, __vue_options__
var __vue_styles__ = {}

/* styles */
__webpack_require__(25)

/* script */
__vue_exports__ = __webpack_require__(21)

/* template */
var __vue_template__ = __webpack_require__(35)
__vue_options__ = __vue_exports__ = __vue_exports__ || {}
if (
  typeof __vue_exports__.default === "object" ||
  typeof __vue_exports__.default === "function"
) {
__vue_options__ = __vue_exports__ = __vue_exports__.default
}
if (typeof __vue_options__ === "function") {
  __vue_options__ = __vue_options__.options
}

__vue_options__.render = __vue_template__.render
__vue_options__.staticRenderFns = __vue_template__.staticRenderFns

module.exports = __vue_exports__


/***/ }

},[426]);


// WEBPACK FOOTER //
// static/index.609a13c.js